import type { IFrameMessage } from "@/enums";
import getOldIframeDomain from "@/helpers/routes/getOldIframeDomain";

/**
 * This function send a message to the OLD Manager (the iframed one)
 */
export default (message: IFrameMessage, content: object) => {
  const iframe = document.querySelector(".old-manager") as HTMLIFrameElement;

  if (!iframe || !iframe.contentWindow) {
    return;
  }

  iframe.contentWindow.postMessage(
    {
      message,
      ...content,
    },
    getOldIframeDomain(),
  );
};
